export default __webpack_public_path__ + "static/media/022-peanut.73d8467e.svg";